import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TimeAgo from "react-timeago";
import Icon from '@material-ui/core/Icon';
import ReactPlayer from 'react-player';
import { Link } from "routes";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import {getMobileNewsItemVideoThumbnail, getDesktopNewsItemVideoThumbnail, extractYoutubeVideoID} from '/utils/common'
import PlayIconButton from '/components/playIconButton';
import Fab from '@material-ui/core/Fab';
import CustomImage from '/components/customImage';

const styles = theme => ({
  playBtn: {
    background: 'rgba(0, 0, 0, 0.4)', 
    position: 'absolute', 
    border: '1px solid #fff',
    verticalAlign: 'middle',
    position: 'absolute',
    top: 125,
    bottom: 0,
    margin: 'auto',
    width: 35,
    height: 35,
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.7)'
    },
    '&:focus': {
      background: 'rgba(0, 0, 0, 0.9)'
    },
    [theme.breakpoints.only('xs')]: {
      width: 45,
      height: 45,
      top: 197
  },
  },
  root: {
    flexGrow: 1,
  },
  imageWrapper: {
    width: 230,
    height: 128,
    [theme.breakpoints.only('xs')]: {
        width: '100%',
        height: '100%'
    },
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: 200,
    objectFit: 'cover'
  },
  itemContainer:{
    padding: '20px 0px 20px'
  },
  time: {
    // cursor: 'pointer',
    fontSize: 12,
    display: 'inline',
   
    },
    timeIcon: {
        paddingRight: 17,
        fontSize: 12,
    },
    date: {
        marginLeft: 5
    },
    categoryName: {
        textTransform: 'uppercase',
        fontSize: 10,
        fontWeight: 500,
        cursor: 'pointer'
    },
    description: {
      cursor: 'pointer'
    },
    title: {
      cursor: 'pointer'
    }
});

function ResultItems(props) {
  const { item, classes } = props;
  const videoUrlThumbnail = item.video_url ? getDesktopNewsItemVideoThumbnail(extractYoutubeVideoID(item.video_url)) : '';
  const videoThumbnail = item.video ? item.video.posters.thumb : '' 
  return (
    <div className={classes.root}>
      <Grid container
            direction="row"
            justify="center"
            alignItems="center" className={classes.itemContainer} spacing={16}>
        <Grid item>
          <div className={classes.imageWrapper}>
          {item.type === 'VIDEO' || item.type === 'VIDEO_URL' || item.video || item.video_url ? 
                    (item.video || item.video_url ?
                      <div style={{position: 'relative', display: 'initial'}}>
                          <Link route={`${item.path}`}>
                            <a className="anchor-link">
                              <CustomImage 
                                imgSrc={item.type === 'VIDEO' ? videoThumbnail : videoUrlThumbnail}
                                imgClass={classes.img}
                                customStyle={`cursor: pointer;`} 
                              /> 
                              <span style={{justifyContent: 'center', display: 'flex'}}>
                                <Fab className={classes.playBtn} >
                                  <Icon style={{color: '#fff'}}>play_arrow</Icon>
                                </Fab>
                              </span>
                            </a>
                        </Link>
                      </div>
                       :
                       <Link route={`${item.path}`}>
                        <a className="anchor-link">
                          <CustomImage // for default
                            imgSrc="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png"
                            imgClass={classes.img}
                            customStyle={`cursor: pointer;`} 
                          /> 
                        </a>
                       </Link>
                        ): 
                        (item.cover.teaser || item.graphic.thumb ?
                          <Link route={`${item.path}`}>
                            <a className="anchor-link">
                            <CustomImage 
                              imgSrc={item.cover.teaser || item.graphic.thumb}
                              imgClass={classes.img}
                              customStyle={`cursor: pointer;`} 
                            /> 
                            </a>
                          </Link>
                            : 
                          <Link route={`${item.path}`}>
                            <a className="anchor-link">
                            <CustomImage // for default
                              imgSrc="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png"
                              imgClass={classes.img}
                              customStyle={`cursor: pointer;`} 
                            /> 
                            </a>
                          </Link>
                        )
                        }
          </div>
        </Grid>
        <Grid item xs={12} sm container>
          <Grid item xs container direction="column" spacing={16}>
            <Grid item xs>
              <Link route={`${item.category.path}`}>
                <a className="anchor-link">
                  <Typography gutterBottom variant="caption" style={{
                                color: item.category.color
                            }} className={classes.categoryName}>
                  {item.category.name}
                  </Typography>
                </a>
              </Link>
              <Link route={`${item.path}`}>
                <a className="anchor-link">
                  <Typography gutterBottom className={classes.title}>
                    {fontUniOrConvertZawgyi(item.title)}              
                  </Typography>
                  <Typography color="textSecondary" className={classes.description}>{fontUniOrConvertZawgyi(item.description)}</Typography> 
                </a>
              </Link>
           </Grid>
            <Grid item>
              <div className={classes.time}>
                  <Icon className={classes.timeIcon}>access_time</Icon>
                  <TimeAgo className={classes.date} date={item.published_date.date} />
              </div>
              {/* <Typography style={{ cursor: 'pointer' }}>Remove</Typography> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider className={classes.customDivider}/>
    </div>
  );
}

ResultItems.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ResultItems);
